import * as React from 'react';
import { TabTableContainer, Title } from '@screens/players/player.details.tabs/tabs.tables.styles';
import { PlayerDataProps } from '@screens/players/types/player.data.props';
import { useAuth } from '@domain/auth/auth.hook';
import { CancelToken } from 'axios';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { noopArray } from '@domain/utils/function.utils';
import { MainDataGrid } from '@components/datagrid/main.data.grid';
import { formatColWithDate, valueGridMoneyFormatter } from '@components/datagrid/custom.datagrid.props';

const columns = [
  { field: 'cash', headerName: 'Greens', width: 140, valueFormatter: valueGridMoneyFormatter },
  { field: 'coins', headerName: 'Chips', width: 140, valueFormatter: valueGridMoneyFormatter },
  { field: 'message', headerName: 'Message', width: 370 },
  { field: 'datee', headerName: 'Date', ...formatColWithDate, width: 150 },
  { field: 'name', headerName: 'Name', width: 220 },
  { field: 'collectionDate', headerName: 'Collection Date', ...formatColWithDate, width: 174 },
];

interface ReverseData {
  cash: number;
  coins: string;
  message: string;
  datee: number;
  name: number;
  collectionDate: string;
}

let index = 0;
function createData(playerReverse: ReverseData) {
  index += 1;
  return { id: index, ...playerReverse };
}

const PlayerPaymentsReverse = ({ player }: PlayerDataProps) => {
  const { authorizedServices } = useAuth();
  const { pid } = player;

  async function runSearch(requestPid: number, page: number, cancelToken: CancelToken | undefined) {
    return authorizedServices.get<ReverseData[]>(`/admin/reverse/player/${requestPid}`, { params: { page }, cancelToken });
  }
  const { responseData, pageCount, loading, error } = usePagedData(pid, runSearch, { placeholderData: noopArray });

  const rows = responseData?.map(createData) || [];
  // const rows = responseData || [];

  const total = rows.length;

  return (
    <>
      <TabTableContainer>
        <Title>Reverse ({total})</Title>
        <MainDataGrid columns={columns} rows={rows} loading={loading} error={error} pageCount={pageCount} />
      </TabTableContainer>
    </>
  );
};

export default PlayerPaymentsReverse;
